module.exports = __webpack_public_path__ + "img/palmas-resort-3.69157b5a.jpg";